module.exports = __webpack_public_path__ + "ph.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ph.svg
// module id = 1010
// module chunks = 0